package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText

import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties


@Page("android_questions")
@Composable
fun QuestionsAndroidPage() {
    BlogLayout(
        PageProperties(
            "Interview Question",
            ""
        ),
        BlogProperties("Android", "Interview Question")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ol {
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Heap Memory in Android",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Heap memory is the runtime memory area where objects are allocated in Android apps. Each app gets a limited heap size, and when it’s exceeded, you get an OutOfMemoryError (OOM).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ol {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Managed by ART/Dalvik — Automatic garbage collection.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "App-specific limit — Varies by device (typically 16MB-512MB+).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Shared across threads — All threads in your app share the same heap.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Garbage collected — Unused objects are automatically cleaned up.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is ADB?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "ADB, short for “Android Debug Bridge”, is a command-line tool that lets you communicate with an Android device (phone, tablet, emulator) from your computer. It acts as a bridge between your development machine and the Android device, allowing you to perform a variety of actions like installing and debugging apps, transferring files, viewing device logs, and even issuing commands that modify system behaviors.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How Does ADB Work?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "ADB works by establishing a connection between a host (your development machine) and a target (your Android device or emulator). The communication between these two is made possible through a TCP/IP connection, USB, or even wireless modes (for Wi-Fi debugging).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Client: This is you! The command-line tool where you run your ADB commands.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Daemon (adbd): This runs on the device and processes commands sent by the client.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Server: Manages the communication between the client and the daemon. It ensures that the client and daemon are talking to each other over a proper connection.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is Armv7?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "There are 3 CPU architectures in Android.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "ARMv7 is the most common as it is optimised for battery consumption.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "ARM64 is an evolved version of that that supports 64-bit processing for more powerful computing.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "ARMx86, is the least used for these three, since it is not battery friendly. It is more powerful than the other two.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is ANR in Android?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "ANR(Application is Not Responding) is a popup that appears when the application is not responding.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "ANR dialogue is displayed whenever the main thread within an application has been unresponsive for a long time under the following conditions:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When there is no response to an input event even after 5 seconds.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When a broadcast receiver has not completed its execution within 10 seconds.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why bytecode cannot be run in Android?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Android uses DVM (Dalvik Virtual Machine ) rather using JVM(Java Virtual Machine).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why does the Android app startup become slow even when the code hasn’t changed?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "PGO (Profile Guided Optimization) Loss: Android Runtime (ART) optimizes your app based on usage patterns. If the OS clears the “Profile” (due to a system update or cache clearing), the app reverts from fully compiled OAT (machine code) back to JIT (interpreted code), which is significantly slower.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Cloud Profile Sync: If the Google Play Store’s Cloud Profile becomes stale or incompatible with a minor OS patch, your app might lose its “Baseline Profile” optimization until it is manually re-indexed by the system during idle charging.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Database Fragmentation",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "SharedPrefs/Data Inflation: If your app stores user data in SharedPreferences, the XML file grows over time. Since SharedPreferences loads the entire file into memory synchronously on first access, a 200KB file can cause a multi-hundred-millisecond stall.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "External Storage Latency: If your app scans the device’s MediaStore or file system for “Recent Items,” the time taken increases as the user accumulates more files on their device.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Server-Side Latency",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Network Type Transition",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Background Contention",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Memory Pressure (LMK)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain DDMS in brief.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The Dalvik Debug Monitor Server (DDMS) is a debugging tool in Android Studio. The DDMS tool is now deprecated and Android now suggests the users use Android Profiler instead. It has a wide range of debugging features, such as:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Port forwarding",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Location data spoofing",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Screen capture",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Logcat",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Radio state information",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Thread and Heap information",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the build process in Android.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The first step consists of the compilation of the resources folder using the Android Asset Packaging Tool (AAPT). These are compiled into a single class file known as R.java, which only holds constants.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In the second step, the java source code needs to be compiled to .class files using javac, which are then converted to Dalvik bytecode using the ‘dx’ tool, which is one of the tools in the software development kit. The final output file is classes.ex.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In the third and final step, the Android apk builder is required to take all the inputs and build the Android Packaging Key (APK) file.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What happens when we tap an Android app icon??",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "Launcher (a specialized home app) sends an Intent to start our app's main activity.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The ActivityManagerService (AMS) checks if our app's process is already running. If not, it creates a new Linux process via Zygote (Android's process spawner).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The app's Application class is instantiated, triggering its onCreate().",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Finally, the launcher Intent launches the MainActivity, executing its onCreate(), onstart(), and onResume () methods.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What occurs when the “Run” button is clicked in Android Studio?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "As soon as you click on the run button below process starts in the background for the Gradle system:",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Build Process: Android Studio triggers the Gradle build process for your project. Gradle is responsible for compiling your Java/Kotlin code, packaging resources, and generating the APK (Android Package) file.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Resource Compilation: Resources such as layouts, drawables, and strings are compiled and processed to be included in the APK.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Manifest Merging: If your project includes libraries or modules, Android Studio merges their manifests with your app’s manifest to create the final manifest file.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Code Inspection: Android Studio performs code inspection to check for errors, warnings, or potential issues in your code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Lint Checking: Android’s Lint tool checks your code and resources for potential performance, usability, and security issues.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Instant Run (Optional): If Instant Run is enabled, Android Studio attempts to push only the changed code and resources to the running app on the device or emulator, speeding up the build and deployment process.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Deployment: Once the build is successful, Android Studio deploys the APK to the selected device or emulator.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Launch: Finally, Android Studio launches the app on the device or emulator for testing.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How do APK and app bundles differ in terms of their configurations and contents?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An APK (Android Application Package) and an Android App Bundle (AAB) are both ways to package and distribute Android apps, but they have some key differences in terms of configuration and what they include:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            SpanText(
                                text = "APK (Android Application Package):",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Configuration: The APK is a single, compiled file that contains all the resources and code necessary to run an Android application on a device. It includes all the compiled code (DEX files), resources (such as images and XML files), and the manifest file that describes the app’s structure and requirements.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Contents: The APK includes resources and code for all device configurations (such as different screen densities or CPU architectures). This can result in larger APK sizes, especially when including resources for multiple device configurations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            SpanText(
                                text = "Android App Bundle (AAB)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Configuration: The Android App Bundle is a publishing format that includes compiled code and resources but does not contain everything needed to run the app on a device. Instead, it contains the app’s compiled code (DEX files), resources, and a manifest file, as well as a set of split APKs for different device configurations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Contents: The AAB does not include resources for all device configurations in a single package. Instead, it includes split APKs (also known as “splits”) that contain resources optimized for specific device configurations. When a user installs an app from the Play Store, the Play Store dynamically generates an APK that includes only the resources and code necessary for the user’s device.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between R8 & D8 tools?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "R8 and D8 are both tools used in the Android build process for code optimization and transformation, but they serve different purposes:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            SpanText(
                                text = "D8 (Dexer 8)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "D8 is the Dexer for Android, responsible for converting Java bytecode into Dalvik bytecode (DEX format) that can run on Android devices.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "D8 is used in the Android build process to transform Java bytecode (.class files) into DEX files, which are then packaged into the final APK.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "D8 performs various optimizations, such as dead code elimination, method inlining, and bytecode simplification, to improve the performance and size of the resulting DEX files.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            SpanText(
                                text = "R8 (Shrinking, Optimization, and Obfuscation Tool):",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "R8 is a code shrinker, optimizer, and obfuscator for Android apps. It replaces ProGuard as the default tool for these tasks in newer versions of the Android Gradle Plugin.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "R8 analyzes the code and resources of your app and removes unused classes, fields, and methods to reduce the size of the APK.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "R8 also performs optimizations similar to D8, such as inlining and simplification, to improve the runtime performance of the app.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Additionally, R8 can obfuscate the code by renaming classes, methods, and fields to make it harder for reverse engineering.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why Use SavedStateHandle?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It acts as a key-value storage mechanism specifically designed for ViewModels. This allows ViewModels to persist essential UI state data that needs to survive configuration changes (e.g., screen rotation) and, in some cases, even process death (when the entire app process is terminated by the Android system).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            class MyViewModel(private val savedStateHandle: SavedStateHandle) : ViewModel() {
                                // ... your ViewModel logic
                            }
                        """.trimIndent()
                    )
                }

                //Fragment
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why use only the default constructor for Fragments?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Using the default constructor ensures the system can recreate the Fragment during configuration changes or process restarts.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "createRefs) and createRef(): createRefs is used to assign multiple references in one go, while createRef is used for a single reference.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Parent Constraints: You can constrain elements to the edges of the parent ConstraintLayout to position them at specific locations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does RecyclerView work internally?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "RecyclerView is a useful and flexible Android component designed for efficiently displaying large datasets by recycling item views instead of inflating new ones repeatedly. It achieves this efficiency using an object pool-like mechanism for managing views, known as the ViewHolder pattern.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Recycling Views: RecyclerView reuses existing views rather than creating new ones for every item in the dataset. When a view scrolls out of the visible area, it is added to a view pool (known as RecyclerView.RecycledViewPool) instead of being destroyed. When a new item comes into view, RecyclerView retrieves an existing view from this pool if available, avoiding the overhead of inflation.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "ViewHolder Pattern: RecyclerView uses a ViewHolder to store references to the views within an item layout. This prevents repeated calls to findViewById() during binding, which improves performance by reducing layout traversal and view lookup.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Adapter’s Role: The RecyclerView.Adapter bridges the data source and the RecyclerView. The adapter’s onBindViewHolder() method binds data to the views when they are reused, ensuring that only the visible items are updated.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "RecycledViewPool: The RecycledViewPool serves as the object pool where unused views are stored. It allows RecyclerView to reuse views across multiple lists or sections with similar view types, further optimizing memory usage.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Scrolling and Item Visibility: As the user scrolls, items that go out of view are detached from the RecyclerView but are not destroyed. Instead, they are added to the RecycledViewPool.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Rebinding Data to Recycled Views: When new items come into view, RecyclerView first checks the RecycledViewPool for an available view of the required type. If a match is found, it reuses the view by rebinding it with new data using onBind-ViewHolder().",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Inflation if No View is Available: If no suitable view is available in the pool, RecyclerView inflates a new view using onCreateViewHolder().",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Efficient Memory Usage: By recycling views, RecyclerView minimizes memory allocation and garbage collection, which can cause performance issues in scenarios involving large datasets or frequent scrolling.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                //https://medium.com/@sivavishnu0705/2115e83d8b88
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the explicit operational difference between Detached and Recycled views?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A detached view is temporarily hidden or separated from the view array during an active layout pass and is typically reattached quickly during layout calculations without altering its underlying data.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A recycled view has been explicitly removed from the active layout context, stripped of its data position identity, and placed into a pool where it must pass through onBindViewHolder() before it can safely appear on-screen again.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                //https://medium.com/@sivavishnu0705/2115e83d8b88
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Can a slow onCreateViewHolder call cause frame drops if it only runs at the beginning?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes. If your list features a wide variety of distinct ViewType allocations, onCreateViewHolder() calls will fire mid-scroll as new item types surface for the first time. If the layout inflation time exceeds the display panel's frame budget, users will experience a stutter during scroll execution.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "ConstraintLayout",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Anchors and Constraints: Constraints define relationships between UI elements, using anchors like top, bottom, start, and end.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "createRefs) and createRef(): createRefs is used to assign multiple references in one go, while createRef is used for a single reference.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Parent Constraints: You can constrain elements to the edges of the parent ConstraintLayout to position them at specific locations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is a Content Provider?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Content Providers manage access to a structured set of data. They encapsulate the data and provide mechanisms for defining data security. Content Providers can be used to share data between different applications or even within the same application.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "createRefs) and createRef(): createRefs is used to assign multiple references in one go, while createRef is used for a single reference.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Parent Constraints: You can constrain elements to the edges of the parent ConstraintLayout to position them at specific locations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Types of Service",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ol {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Foreground Service: A service that is bound to a notification. It continues running even when the user is not interacting with the app. For example, music players and fitness-tracking apps.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Background Service: A service that runs in the background without user interaction. Android has restrictions on these services to conserve resources.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Bound Service: A service that allows components such as activities to bind to it, interact with it, and communicate with it.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Service Lifecycle",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "onCreate(): Called when the service is first created. This is where you initialize the service.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "onStartCommand(): Called each time a client starts the service using startService(). This is where you define the logic for the service.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "onBind(): Called when a component binds to the service using bindService(). Returns an IBinder object for communication with the service.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "onUnbind(): Called when all clients have disconnected from a particular interface published by the service.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "onRebind(): Called when a client rebinds to the service after it had previously been disconnected.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "onDestroy(): Called when the service is no longer used and is being destroyed. Clean up resources here.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When the device rotates, which lifecycle method is typically called after onPause()?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "During configuration changes, onPause () is followed by onStop() and then onDestroy) before recreation.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain Android Push Notification Flow using FCM?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "FCM (Firebase Cloud Messaging) push notification flow involves three main components: the FCM server, your app server, and the client app. When you want to send a notification, your app server sends a message to FCM with the device token and payload. FCM then routes this message to the appropriate device where the client app receives it through FirebaseMessagingService and displays the notification.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }
        }
    }
}

// If app is in playstore, how to find crash root cause
// Coroutine apart from cancel, how can you cancel coroutine (https://medium.com/@prakash_ranjan/best-practices-for-coroutine-cancellation-and-non-cancellation-in-kotlin-3ae214cb1c0e)

// Android Automotive OS Architecture
//https://outcomeschool.substack.com/p/caching-in-android-improving-performance
//https://medium.com/@sandeep.jan19/android-interview-deep-dive-part-1-kotlin-immutability-thread-safety-for-senior-developers-47a3c977db5b
//https://medium.com/@rohitsurthi/solid-principles-cheat-sheet-for-android-developers-de57cafe1bfd
//https://medium.com/@kumarpriyansu367/android-memory-management-for-modern-app-engineering-2a493b4d1b2a
//https://www.droidunplugged.com/2026/01/cracking-android-sde2sde3-interviews-in.html
//https://medium.com/@karishma-agr1996/top-50-interview-questions-for-a-senior-android-engineer-role-part-2-cbed4c6d6058
//https://blog.stackademic.com/crack-the-android-interview-part-1-lifecycle-context-fa10b77d70a7
//https://karishma-agr1996.medium.com/top-50-interview-questions-for-a-senior-android-engineer-role-part-2-cbed4c6d6058

//System Design
//https://codefarm0.medium.com/designing-a-debit-card-processing-system-pin-authentication-bank-integration-real-time-balance-5c07a4f76ffd
//https://www.linkedin.com/pulse/600-android-developer-interview-questions-answers-20102026-komilov-5rbpe/